import React from 'react';
import { useStreamedText, sliceStream } from '../hooks/useStreamedText';

interface ChatBubbleProps {
  role: 'user' | 'assistant';
  content: string;
  /** Stream assistant text in like ChatGPT. Off for history. */
  animate?: boolean;
}

export const ChatBubble: React.FC<ChatBubbleProps> = ({ role, content, animate = false }) => {
  const isUser = role === 'user';
  const streaming = Boolean(animate) && !isUser;
  const stream = useStreamedText([content], streaming);
  const { parts } = sliceStream([content], stream.visible);
  const shown = streaming ? parts[0] : content;

  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: isUser ? 'flex-end' : 'flex-start',
      marginBottom: 16
    }}>
      <div style={{
        maxWidth: '85%',
        padding: '10px 14px',
        borderRadius: isUser ? '18px 18px 4px 18px' : '18px 18px 18px 4px',
        backgroundColor: isUser ? 'var(--accent-color)' : 'var(--bg-card)',
        color: isUser ? '#17120a' : 'var(--text-primary)',
        fontSize: 14,
        lineHeight: 1.5,
        whiteSpace: 'pre-wrap',
        boxShadow: '0 1px 2px rgba(0,0,0,0.4)'
      }}>
        {shown}
        {streaming && !stream.done && <span className="stream-caret" aria-hidden />}
        {streaming && !stream.done && (
          <button type="button" className="stream-skip is-inline" onClick={stream.skip}>
            显示全部
          </button>
        )}
      </div>
      <div style={{ 
        fontSize: 10, 
        color: 'var(--text-secondary)', 
        marginTop: 4,
        marginLeft: isUser ? 0 : 4,
        marginRight: isUser ? 4 : 0
      }}>
        {isUser ? '您' : 'AI 解读'}
      </div>
    </div>
  );
};
